import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
interface SwipesStatsStore {
    userId: number | null;
    setUserId: (val: number) => void;
}
export const useSwipesStats = create<SwipesStatsStore>()(
    devtools(
        immer((set, _) => ({
            userId: null,
            setUserId: (val: number) => set({
                userId: val
            }),
        })),
    ),
);
